import { combineReducers } from "redux";
import { Currency } from "../../types";
import { getFailureActionType, getSuccessActionType } from "../../utils";
import { FETCH_CURRENCY_REQUEST } from "./constants";
import { Action } from "./types";

function item(state: Partial<Currency> = {}, action: Action): Partial<Currency> {
  switch (action.type) {
    case getSuccessActionType(FETCH_CURRENCY_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

function isFetching(state = false, action: Action) {
  switch (action.type) {
    case FETCH_CURRENCY_REQUEST:
      return true;

    case getSuccessActionType(FETCH_CURRENCY_REQUEST):
    case getFailureActionType(FETCH_CURRENCY_REQUEST):
      return false;

    default:
      return state;
  }
}

export const currency = combineReducers({ item, isFetching });
